import { calculatePKCECodeChallenge } from 'oauth4webapi';
// This must match the output of `calculatePKCECodeChallenge`
const CODE_CHALLENGE_METHOD = 'S256';
export const generateAuthorizationUrl = async ({ authorizationEndpoint, responseType, clientId, redirectCallbackUrl, codeVerifier, state, scopes, extraParameters, }) => {
    const codeChallenge = await calculatePKCECodeChallenge(codeVerifier);
    const scopesStr = scopes.join(' ');
    const authUrl = new URL(authorizationEndpoint);
    const search = authUrl.searchParams;
    search.set('client_id', clientId);
    search.set('response_type', responseType);
    search.set('redirect_uri', redirectCallbackUrl.href);
    search.set('scope', scopesStr);
    search.set('state', state);
    search.set('code_challenge', codeChallenge);
    search.set('code_challenge_method', CODE_CHALLENGE_METHOD);
    if (extraParameters) {
        Object.entries(extraParameters).forEach(([key, value]) => search.set(key, value));
    }
    return authUrl.href;
};
